// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__wjspQ","content":"styles_content__BJ2Rl","flexButton":"styles_flexButton__2okuh","formikErrors":"styles_formikErrors__1A_cQ"};